import {config} from "../../config";

const localStorageSetItem = (key: string, value: string|number|object|Array<any>|any) => {
    localStorage.setItem(key, value);
}

const localStorageGetItem = (key: string) => {
    return localStorage.getItem(key);

}

const sessionStorageSetItem = (key: string, value: string|number|object|Array<any>|any) => {
    sessionStorage.setItem(key, value);
}

const sessionStorageGetItem = (key: string) => {
    return sessionStorage.getItem(key);
}

const getAccessToken = () => {
    const impersonationToken = getImpersonationToken();
    if (impersonationToken) {
        return impersonationToken;
    }

    let account : any = localStorageGetItem(config.LOCAL_STORE.ACCOUNT);
    try {
        account = JSON.parse(account);
        return account.access_token;
    }catch (err){  }
    return null;
}

const getImpersonationToken = () => {
    return localStorageGetItem(config.LOCAL_STORE.ACCOUNT_SWITCH) || sessionStorageGetItem(config.LOCAL_STORE.ACCOUNT_SWITCH) || null;
}

const setImpersonationToken = (token: string) => {
    localStorageSetItem(config.LOCAL_STORE.ACCOUNT_SWITCH, token);
    sessionStorageSetItem(config.LOCAL_STORE.ACCOUNT_SWITCH, "");
}

const setImpersonationUser = (user: object | null) => {
    if (!user) {
        localStorageSetItem(config.LOCAL_STORE.ACCOUNT_SWITCH_USER, "");
        return;
    }
    localStorageSetItem(config.LOCAL_STORE.ACCOUNT_SWITCH_USER, JSON.stringify(user));
}

const getImpersonationUser = (): any | null => {
    try {
        const raw = localStorageGetItem(config.LOCAL_STORE.ACCOUNT_SWITCH_USER);
        if (!raw) {
            return null;
        }
        return JSON.parse(raw);
    } catch {
        return null;
    }
}

const clearImpersonationToken = () => {
    localStorageSetItem(config.LOCAL_STORE.ACCOUNT_SWITCH, "");
    sessionStorageSetItem(config.LOCAL_STORE.ACCOUNT_SWITCH, "");
    localStorageSetItem(config.LOCAL_STORE.ACCOUNT_SWITCH_USER, "");
}


export const __store = {
    localStorageGetItem,
    sessionStorageGetItem,
    localStorageSetItem,
    sessionStorageSetItem,
    getAccessToken,
    getImpersonationToken,
    setImpersonationToken,
    setImpersonationUser,
    getImpersonationUser,
    clearImpersonationToken,
}
